<crownx-overlay-shadow id="modal-layover" [IsOverlayShadowVisible]="IsModalLayoverVisible" [ZIndex]="9999"></crownx-overlay-shadow>